import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 担当者別の年間見積、受注実績の検索
 */
export function SearchAnnualNumberAndAcceptByUserData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchAnnualNumberAndAcceptByUserData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
/**
 * //個人受注実績を保存
 */
export function updateAnnualNumberAndAcceptData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateAnnualNumberAndAcceptData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑
